"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _useHoverCycle = _interopRequireWildcard(require("web/shared/icons/useHoverCycle"));
var _SearchBar = require("web/shared/components/SearchBar.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The shared search input: a rounded "pill" text field with a magnifying glass
* riding its left edge (the icon stays put while typing), filling the width of
* its row, and a clear mark at its right edge whenever there is something to
* clear, always shown rather than only on hover as a browser's own is. It is
* a thin controlled input — the caller owns the query string and decides what
* the change drives (a local filter or a server round-trip).
*/
function SearchBar(_ref) {
  let value = _ref.value,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    ariaLabel = _ref.ariaLabel;
  const inputRef = (0, _react.useRef)(null); // The clear mark plays its motion while pointed at.
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    clearPointed = _useState2[0],
    setClearPointed = _useState2[1];
  const clearProgress = (0, _useHoverCycle.default)(clearPointed, _useHoverCycle.QUICK_GLYPH_CYCLE_MS);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_SearchBar.styles.wrap)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_SearchBar.styles.icon)), {}, {
      "aria-hidden": "true",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        name: "magnifying-glass",
        size: "s"
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", (0, _objectSpread2.default)({
      type: "search",
      value: value,
      onChange: event => onChange(event.target.value),
      placeholder: placeholder,
      "aria-label": ariaLabel != null ? ariaLabel : placeholder,
      ref: inputRef
    }, stylex.props(_SearchBar.styles.search))), value.length === 0 ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      type: "button",
      "aria-label": "Clear search",
      onClick: () => {
        var _inputRef$current; // The mark leaves with the text, so no leave event will come.
        setClearPointed(false);
        onChange("");
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      },
      onMouseEnter: () => setClearPointed(true),
      onMouseLeave: () => setClearPointed(false)
    }, stylex.props(_SearchBar.styles.clear)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        name: "x-mark",
        size: "xs",
        progress: clearProgress
      })
    }))]
  }));
}
var _default = exports.default = SearchBar;